import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragAndDropDirective } from './drag-and-drop.directive';
import { PercentageDirective } from './percentage.directive';
import { NowhitespaceDirective } from './nowhitespace.directive';
import { DigitOnlyDirective } from './digit-only.directive';
import { AlphabetOnlyDirective } from './alphabet-only.directive';
import { AlphaNumOnlyDirective } from './alpha-num-only.directive';

@NgModule({
  declarations: [
    DragAndDropDirective,
PercentageDirective,
NowhitespaceDirective,
DigitOnlyDirective,
AlphabetOnlyDirective,
AlphaNumOnlyDirective  
  ],
  imports: [
    CommonModule
  ],
  exports:[
    DragAndDropDirective,
    PercentageDirective,
    NowhitespaceDirective,
    DigitOnlyDirective,
    AlphabetOnlyDirective,
    AlphaNumOnlyDirective    
  ]
})
export class DirectivesModule { }
